export default {
  showImageFullHeight: true,
  fareItemDate: {},
  fareItemDepartureInfo: {},
  fareItemReturnInfo: {},
  fareItemJourneyType: {},
  fareItemTravelClass: {},
  fareItemOriginDestination: {},
  fareItemPrice: {},
  fareBodyItem: {},
  fareFooterItem: {},
  fareItemCard: {},
  fareItemTripDuration: {},
  fareItemPill: {
    bgColor: 'dark',
    textColor: 'white',
    marginTop: '2',
    marginRight: '2',
    paddingTop: '2px',
    paddingBottom: '2px',
    textAlign: 'center',
    rounded: '3',
    style: { minWidth: '40px' }
  },
  fareItemNoPriceAvailable: {},
  fareItemCallToAction: {},
  fareItemCallToActionContainer: {},
  tabIndex: true,
  tabIndexCallToAction: true,
  showDate: false,
  showOriginDestination: true,
  showJourneyType: true,
  showTravelClass: true,
  showDepartureInfo: true,
  showReturnInfo: true,
  showPill: true,
  showPrice: true,
  showDurationTrip: true,
  showMiles: false,
  showDepartureReturnBeforePrice: false,
  showHorizontalSeparator: false,
  showCallToAction: false,
  separatorDatesProps: {},
  separatorJourneyTypeProps: {},
  fareItemDepartureReturn: {},
  fareItemJourneyTypeTravelClass: {},
  fareItemBackgroundImage: {},
  fareItemHorizontalSeparator: {},
  onClick: () => {},
  callToActionOnClick: () => {},
  onKeyDown: () => {},
  flavor: 'fareItemCardWithoutBackgroundImage',
  interactionHotZone: 'smart',
  usedErrorBoundary: true,
  dataTestId: '',
  data: null,
  navigationInfo: '',
  showBackgroundImage: true,
  focusReferences: () => {},
  onFocus: () => {},
  experimentalRenderAtoms: false,
  availableAtoms: [
    'FareItemOriginDestination',
    'FareItemTripDuration',
    'FareItemSeparator',
    'FareItemPrice',
    'FareItemDepartureReturnInfo',
    'FareItemJourneyTypeTravelClass',
    'FareItemCallToAction'
  ],
  fareItemRoute: {},
  showRoute: false,
  fareItemTags: {}
};
